import { render, staticRenderFns } from "./Zhuanyuan.vue?vue&type=template&id=a92b270a&scoped=true"
import script from "./Zhuanyuan.vue?vue&type=script&lang=js"
export * from "./Zhuanyuan.vue?vue&type=script&lang=js"
import style0 from "./Zhuanyuan.vue?vue&type=style&index=0&id=a92b270a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92b270a",
  null
  
)

export default component.exports